import { Center, LoadingOverlay } from '@mantine/core';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SubscriptionS from '../../../Service/restapi/subscriptionService';

const CancelSubscriptionDispatcher = () => {
  const navigate = useNavigate();

  useEffect(() => {
    verify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verify = async () => {
    try {
      await SubscriptionS.cancelChargebeeSubscription();
    } finally {
      navigate('/settings/plans');
    }
  };

  return (
    <Center sx={{ position: 'relative', height: '100vh', width: '100vw' }}>
      <LoadingOverlay visible overlayBlur={2} loaderProps={{ size: 'xl' }} />
    </Center>
  );
};

export default CancelSubscriptionDispatcher;
